
import {  KoDate, KoForm, KoFormBuilder, KoLoader, KoSelect, KoTextArea, KoToast, Upload } from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './paybooksInvoices.module.scss';
import ItemEntryCrud from './itemEntryCrud';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';
// import Driver from 'packages/drivers';




const InvoicesCurd = ({form, handleFinish, initialValues }) => {
  // const [form] =KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };




  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'customer', label: 'Customer Name', colSpan: 2, widget: Customers,rules: [
        {
          required: true,
          message: 'Enter a Customer Name'
        }
      ]  },
      { key: 'Invoices', placeholder: 'Enter a Invoices', label: 'Invoices#' , colSpan: 2,rules: [
        {
          required: true,
          message: 'Enter a invoice'
        }
      ] },
      { key: 'ordernumber', label: 'OrderNumber#' , colSpan: 2},
      { key: 'reference', placeholder: 'Enter a Reference#', label: 'Reference#' , colSpan: 2},
      { key: 'startDate', label: 'Invoice Date', colSpan: 2, widget: Date,rules: [
        {
          required: true,
          message: 'Enter a Date'
        }
      ] },
      { key: 'terms', placeholder: 'Terms', label: 'Terms' , colSpan: 2},
      { key: 'startDate', label: 'Due Date', colSpan: 2, widget: Date },
      { key: 'salesperson', label: 'SalePerson', placeholder:'Select Salesperson', colSpan: 2, widget: Customers},
      { key: '', label: 'Item Table', colSpan: 6, widget: () => <ItemEntryCrud form={form} handleFinish={handleFinish} initialValues={initialValues} /> },
      { key: 'description', widget: KoTextArea, label: 'Customer Notes', colSpan: 6, placeholder: 'Thanks for your business'},
      { key: 'termscondition', widget: KoTextArea, label: 'Terms & Conditions', colSpan: 6, placeholder: 'Enter the terms and conditions of your business to be displayed in your transaction'}


    ]};




  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'documents'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }};

  const normFile = (e) => {
    return e?.file;
  };


  const uploadButton = (
    <div className={styles.dndArea}>
      <KoIcon name='AttachmentOutlined' />
      <div> Purchase Order Attach File</div>
    </div>

  );
  const onRemoveFile = (d) => {
    console.log();
  };


  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  
  return (
    <div  className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <div className={styles.attachments}>
          {/* <div className={styles.attachmentsArea}>
            <Driver DeleteFile={false} action={true} fileType={initialValues?.documents?.aadharDetails?.file?.type} filePath={initialValues?.documents?.aadharDetails?.file.url} handleDelete={() => onRemoveFile(initialValues?.documents?.aadharDetails?.file)} />
          </div> */}
        
          <KoForm.Item
            name={"file"}
            valuePropName={"file"}
            getValueFromEvent={normFile}>

            <Upload {...props}
              className={styles.card}
              onRemove={onRemoveFile}
              showUploadList={{showPreviewIcon : false}}
              showPreviewIcon={true}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </KoForm.Item>
        </div>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};
export default InvoicesCurd;